module.exports = __webpack_public_path__ + "static/favicon-7476f756c13b4579fbffabb05e63bf79.png";